export default "__VITE_ASSET__BJbVsWDz__"